/* eslint-disable max-len */
import { getFetch, hasOwn } from './customLib';

const apiUrl =
	process.env.NODE_ENV === 'production'
		? 'https://bitbns.com'
		: ''; /* process.env.REACT_APP_API_URL */

// const apiUrl2 =
// 	process.env.NODE_ENV === 'production' ? 'https://test.bitbns.com' : '';

export const getGlobalParams = param => {
	let url = `${apiUrl}/jugApi/globalConfig.json`;

	if (param === 'full') {
		url = 'https://bitbns.com/jugApi/globalConfig.json';
	}

	return getFetch(url);
};

export const getSwapCoinsParams = param => {
	let url = `${apiUrl}/bns-swap-order/coin-details`;

	if (param === 'full') {
		url = 'https://bitbns.com/bns-swap-order/coin-details';
	}

	return getFetch(url);
};

const coinParams = {};

const oldCoinNewCoinNameMapping = { sc: 'sia', bsv: 'bchsv', eosdac: 'eosd' };

export const wNotes = {
	erc20: [
		'We do not support withdrawals to smart contract addresses, Make sure you are not sending to smart contract address else your tokens will get **lost forever**.',
		'**Please double check the network while you withdraw**',
	],
	bep20: [
		'We do not support withdrawals to smart contract addresses, Make sure you are not sending to smart contract address else your tokens will get **lost forever**.',
		'**Please double check the network while you withdraw**',
	],
};

const getCoinsList = () =>
	Object.keys(coinParams).filter(coin => !/^(rpx|ven|tst)$/.test(coin));

export const coinsList = [];

export const getCoinProps = (() => {
	const memoized = {
		coin: '',
		props: {},
	};

	return coin => {
		const lowerCoin = typeof coin === 'string' && coin.toLowerCase();

		if (memoized.coin === lowerCoin) {
			return memoized.props;
		}

		const defaultValue = false;

		if (coinsList.indexOf(lowerCoin) > -1) {
			memoized.props = coinParams[lowerCoin];
			return memoized.props;
		}
		return defaultValue;
	};
})();

export const getCoinProperty = (coin, prop) => {
	const lowerCoin = typeof coin === 'string' && coin.toLowerCase();
	const coinProps = getCoinProps(lowerCoin);

	if (hasOwn(coinProps, prop)) {
		return coinProps[prop];
	}
	return false;
};

const getCoinsListWithId = () => {
	const obj = {};
	coinsList.forEach(coin => {
		Object.assign(obj, { [getCoinProperty(coin, 'coinId')]: coin });
	});
	return obj;
};

export const coinsWithIdsList = {};

export const getCoinFromId = coinId => {
	if (Number.isNaN(coinId) || !hasOwn(coinsWithIdsList, coinId)) {
		return '';
	}
	return coinsWithIdsList[coinId];
};

const getCoinsListWithNames = (coinsArr = coinsList) => {
	let list = {};
	coinsArr.forEach(coin => {
		if (/^(rpx|ven|tst)$/.test(coin)) {
			return;
		}
		list = Object.assign(list, {
			[coin]: getCoinProperty(coin, 'coinName'),
		});
	});
	return list;
};

export const coinsListWithNames = {};

export const getDefaultFiatDecimals = market_id => {
	switch (market_id) {
		case 2:
			return 2;
		case 1:
			return 2;
		default:
			return 2;
	}
};

export const getINRDecimals = (coin, market_id) => {
	let fiatDecimals;
	const inrDecimals = getCoinProperty(coin, 'inrDecimals') || 2;
	const usdtDecimals =
		getCoinProperty(coin, 'usdtDecimals') || inrDecimals * 2;

	switch (market_id) {
		case 1:
			fiatDecimals = usdtDecimals;
			break;
		default:
			fiatDecimals = inrDecimals;
	}
	if (fiatDecimals !== false) {
		return fiatDecimals;
	}

	return getDefaultFiatDecimals(market_id);
};

const markets = {
	inr: {
		market_id: 0,
		sym: '₹',
		pair: 'inr',
		coinId: 7,
		type: 'fiat',
		spotSocket: '/bnsINRMSocket/',
		numberFormat: 'en-IN',
		name: 'Indian Rupee',
	},
	usdt: {
		market_id: 1,
		sym: '$',
		pair: 'usdt',
		coinId: 54,
		spotSocket: '/bnsUSDTMSocket/',
		numberFormat: 'en-US',
		name: 'Tether',
	},
	try: {
		market_id: 2,
		sym: '₺',
		pair: 'try',
		spotSocket: '/bnsTRYMSocket/',
		numberFormat: 'en-US',
		name: 'Turkish lira',
		coinId: 495,
		type: 'fiat',
	},
};

export const marketsList = Object.keys(markets);

/** coins that have margin trading enabled */
export const marginCoins = [];

/** coins whose balances will be shown in the wallets page */
export const balanceCoins = [];

/** coins whose crypto deposits are enabled */
export const depositCoins = [];

/** coins whose crypto withdrawals are enabled */
export const withdrawCoins = [];

/** coins whose INR market for trading are enabled */
export const inrCoins = [];

/** coins whose USDT market for trading are enabled */
export const usdtCoins = [];

/** coins whose in Future market */
export const futuresInstruments = [];

export const tryCoins = [];
/** total list of coins available for trading from all markets */
export const tradeCoins = [];

export const swapCoins = [];

/** tokens that we have listed (non-swap) */
export const listedCoins = [];

export const fiatCurrs = [];

export const getActiveSwapCoinsList = () =>
	swapCoins.filter(coin => coinParams[coin].isActiveSwap === 1);

export const moreGlobalParams = {
	poolSale: {
		readme: 'https://medium.com/bitbns/announcement-14-improved-and-grander-pool-sales-1f8275abf7b4',
		vid: 'mRbcqYJdRXI',
	},
	smallBal: 50,
	bnsgRates: {
		bns: '10',
		bnsd: '27.5641025641',
	},
	withLimits: {
		normal: {
			min: 100,
			max: 50000,
			perDay: 2,
			charges: [],
			instructions: [
				'Withdrawal amount should be in whole numbers since decimal amounts are not processed.',
				"INR' withdrawals would be processed within a maximum span of 3 working days",
			],
			limitsNotes: [
				'Withdrawals can only be requested from 10AM to 4PM IST',
			],
		},
		instant: {
			min: 100,
			max: 50000,
			perDay: 2,
			charges: [
				{
					upto: 1000,
					fee: 4,
				},
				{
					upto: 25000,
					fee: 6,
				},
				{
					upto: 200000,
					fee: 9,
				},
			],
			instructions: [
				'Withdrawal amount should be in whole numbers since decimal amounts are not processed.',
				'Withdrawals will be processed instantly',
			],
			limitsNotes: ['Withdrawals are available 24x7'],
		},
	},
	ascentData: {
		pid: 3,
		rates: [
			{
				token: 'usdt',
				rate: 0.15,
			},
			{
				token: 'btc',
				rate: 0.0000048,
			},
			{
				token: 'eth',
				rate: 0.00012,
			},
		],
		startTime: 1612521471,
		endTime: 1612694267,
		factor: 8,
		tokenName: 'SPRINK',
		minAmt: 5,
		customTitle: 'Sprink: Bringing Fun Back Into Daily Food',
	},
	// 0 - manual, 1 - hyperverge, 2 - onfido
	kycProvider: 0,
	bankAccWarnings: [],
};

const getMultiMarketCoins = () =>
	balanceCoins.filter(balCoin => {
		let count = 0;

		tradeCoins.forEach(el => {
			const coin = el.split('-')[0];

			if (coin === balCoin) {
				count += 1;
			}
		});
		if (count > 1) {
			return true;
		}
		return false;
	});

export const multiMarketCoins = [];

export const getCoinsMarket = c => {
	// 0 - coin present in inr market
	// 1 - coin present in usdt market
	// 2 - coin present in both market
	const splitCoin = c.split('-');
	const coin = splitCoin[0];

	if (multiMarketCoins.includes(coin)) {
		return 2;
	}

	if (usdtCoins.includes(coin)) {
		return 1;
	}
	// if (inrCoins.includes(coin)) {
	return 0;
	// }
};

let networkTypes = {};

export const networksList = [];

const networkIdFromName = {};

export const disableDepoNw = [];
export const disableWithdNw = [];

export const updateAppParams = (resp, resp2) => {
	try {
		marginCoins.length = 0;
		balanceCoins.length = 0;
		depositCoins.length = 0;
		withdrawCoins.length = 0;
		inrCoins.length = 0;
		tryCoins.length = 0;
		usdtCoins.length = 0;
		tradeCoins.length = 0;
		swapCoins.length = 0;
		listedCoins.length = 0;

		if (resp.status === 1 && resp2.status === 1) {
			const {
				masterCryptoTransferDisable,
				disableDepoNw: dataDisableDepoNw,
				disableWithdNw: dataDisableWithdNw,
				withLimits: dataWithLimits,
				coins,
				balanceCoins: dataBalanceCoins,
				depositCoins: dataDepositCoins,
				withdrawCoins: dataWithdrawCoins,
				inrCoins: dataInrCoins,
				tryCoins: dataTryCoins,
				usdtCoins: dataUsdtCoins,
				networkTypes: dataNetworkTypes,
				futuresInstruments: dataFuturesInstruments,
				fiatCurrs: dataFiatCurrs = [],
			} = resp.data;
			const dataSwapCoins = resp2.data;

			Object.keys(oldCoinNewCoinNameMapping).forEach(key => {
				const val = oldCoinNewCoinNameMapping[key];
				if (
					dataSwapCoins[key] !== undefined &&
					coins[val] !== undefined
				) {
					dataSwapCoins[val] = dataSwapCoins[key];
					delete dataSwapCoins[key];
				}
			});

			moreGlobalParams.withLimits =
				dataWithLimits || moreGlobalParams.withLimits;

			Object.assign(coinParams, dataSwapCoins, coins);
			Object.keys(coins).forEach(curr => {
				if (dataSwapCoins[curr] !== undefined) {
					coinParams[curr] = {
						...coinParams[curr],
						isActiveSwap: dataSwapCoins[curr].isActiveSwap,
					};
				}
			});

			balanceCoins.push(
				...[
					...new Set([
						...Object.keys(dataSwapCoins),
						...dataBalanceCoins,
					]),
				]
			);

			if (!masterCryptoTransferDisable) {
				depositCoins.push(...dataDepositCoins);
				withdrawCoins.push(...dataWithdrawCoins);
			}

			disableDepoNw.push(...dataDisableDepoNw);
			disableWithdNw.push(...dataDisableWithdNw);

			inrCoins.push(...dataInrCoins);
			tryCoins.push(...dataTryCoins);
			usdtCoins.push(...dataUsdtCoins);
			swapCoins.push(...Object.keys(dataSwapCoins));

			const listed = new Set([...dataInrCoins, ...dataUsdtCoins]);
			listedCoins.push(...listed);
			futuresInstruments.push(...dataFuturesInstruments);
			fiatCurrs.push(...dataFiatCurrs);

			tradeCoins.push(
				...dataInrCoins,
				...dataUsdtCoins.map(coin => `${coin}-usdt`),
				...dataTryCoins.map(coin => `${coin}-try`)
			);
			// tradeCoins.push(
			// 	...[
			// 		...new Set([
			// 			...dataInrCoins,
			// 			...dataUsdtCoins.map(coin => `${coin}-usdt`),
			// 			...swapCoins,
			// 		]),
			// 	]
			// );

			coinsList.push(...getCoinsList());

			Object.assign(coinsWithIdsList, getCoinsListWithId());
			Object.assign(coinsListWithNames, getCoinsListWithNames());

			multiMarketCoins.push(...getMultiMarketCoins());

			networkTypes = dataNetworkTypes;
			Object.keys(dataNetworkTypes).forEach(nw => {
				networksList.push(+nw);
			});
			Object.keys(dataNetworkTypes).forEach(id => {
				const { shortName } = dataNetworkTypes[id];
				networkIdFromName[shortName] = +id;
			});

			return {
				marginCoins,
				balanceCoins,
				depositCoins,
				withdrawCoins,
				inrCoins,
				tryCoins,
				usdtCoins,
				tradeCoins,
				swapCoins,
				listedCoins,
				networksList,
				coins,
				networkTypes,
				multiMarketCoins,
				coinsWithIdsList,
				coinsListWithNames,
				coinsList,
				marketsList,
				futuresInstruments,
				fiatCurrs,
			};
		}
	} catch (error) {
		console.log('updateAppParams', error);
	}
	throw Error('something went wrong');
};

export const initAppParamsApi = async params => {
	try {
		const resp = await getGlobalParams(params);
		const resp2 = await getSwapCoinsParams(params);
		const {
			marginCoins: marginCoinsRet,
			balanceCoins: balanceCoinsRet,
			depositCoins: depositCoinsRet,
			withdrawCoins: withdrawCoinsRet,
			inrCoins: inrCoinsRet,
			tryCoins: tryCoinsRet,
			usdtCoins: usdtCoinsRet,
			tradeCoins: tradeCoinsRet,
			swapCoins: swapCoinsRet,
			multiMarketCoins: multiMarketCoinsRet,
			coinsList: coinsListRet,
			fiatCurrs: fiatCurrsRet,
		} = updateAppParams(resp, resp2);

		marginCoins.push(
			...marginCoinsRet.filter(tok => !marginCoins.includes(tok))
		);
		balanceCoins.push(
			...balanceCoinsRet.filter(tok => !balanceCoins.includes(tok))
		);
		depositCoins.push(
			...depositCoinsRet.filter(tok => !depositCoins.includes(tok))
		);
		withdrawCoins.push(
			...withdrawCoinsRet.filter(tok => !withdrawCoins.includes(tok))
		);
		inrCoins.push(...inrCoinsRet.filter(tok => !inrCoins.includes(tok)));
		tryCoins.push(...tryCoinsRet.filter(tok => !tryCoins.includes(tok)));
		usdtCoins.push(...usdtCoinsRet.filter(tok => !usdtCoins.includes(tok)));
		tradeCoins.push(
			...tradeCoinsRet.filter(tok => !tradeCoins.includes(tok))
		);
		swapCoins.push(...swapCoinsRet.filter(tok => !swapCoins.includes(tok)));
		multiMarketCoins.push(
			...multiMarketCoinsRet.filter(
				tok => !multiMarketCoins.includes(tok)
			)
		);

		fiatCurrs.push(...fiatCurrs.filter(tok => !fiatCurrs.includes(tok)));

		coinsList.push(...coinsListRet.filter(tok => !coinsList.includes(tok)));

		return {
			marginCoins,
			balanceCoins,
			depositCoins,
			withdrawCoins,
			inrCoins,
			usdtCoins,
			tryCoins,
			tradeCoins,
			swapCoins,
			listedCoins,
			networksList,
			networkTypes,
			multiMarketCoins,
			coinsWithIdsList,
			coinsListWithNames,
			coinsList,
		};
	} catch (error) {
		console.log('initAppParamsApi', error);
	}
	throw Error('something went wrong');
};

export const checkNGetTradeCoin = coin => {
	const lowerCoin = String(coin).toLowerCase();

	const index =
		(tradeCoins.indexOf(lowerCoin) + 1 ||
			tradeCoins.indexOf(`${lowerCoin}-usdt`) + 1) - 1;

	if (index > -1) {
		return tradeCoins[index];
	}

	return false;
};

export const getNetworkProps = id => {
	if (id !== '' && networksList.includes(+String(id))) {
		return networkTypes[id];
	}
	return {};
};

export const getNetworkPropsFromName = name => {
	const types = Object.keys(networkIdFromName);

	const lowerName = name.toLowerCase();

	if (types.indexOf(lowerName) > -1) {
		return getNetworkProps(networkIdFromName[lowerName]);
	}
	return {};
};

export const getBaseProps = (() => {
	const memoCache = {
		pair: '',
		props: {},
	};

	return (basePart = 'inr') => {
		const basePair = String(basePart).toLowerCase();
		if (memoCache.pair === basePair) {
			return memoCache.props;
		}

		const defaultProps = markets.inr;

		if (hasOwn(markets, basePair)) {
			memoCache.pair = basePair;
			memoCache.props = markets[basePair];
		}

		return (memoCache.pair && memoCache.props) || defaultProps;
	};
})();

export const getBaseSymbol = (() => {
	const memoCache = {
		coin: '',
		sym: '',
	};

	return coin => {
		const lowerCoin = String(coin).toLowerCase();
		if (memoCache.coin === lowerCoin) {
			return memoCache.sym;
		}

		const defaultSym = '₹';

		marketsList.forEach(mkt => {
			const { sym: mktSym, pair } = markets[mkt];
			const basePairIndex = lowerCoin.indexOf(pair);

			if (basePairIndex > 0) {
				memoCache.coin = lowerCoin;
				memoCache.sym = mktSym;
			}
		});

		return memoCache.sym || defaultSym;
	};
})();

export const getBasePropsFromMarket = (() => {
	const memoCache = {
		market_id: '',
		props: {},
	};

	return (market_id = 0) => {
		if (memoCache.market_id === market_id) {
			return memoCache.props;
		}

		const defaultProps = markets.inr;

		marketsList.forEach(mkt => {
			const { market_id: mkd_id } = markets[mkt];

			if (mkd_id === market_id) {
				memoCache.market_id = market_id;
				memoCache.props = markets[mkt];
			}
		});

		return (memoCache.market_id && memoCache.props) || defaultProps;
	};
})();

export const getPairDetails = (() => {
	const memoCache = {
		sammCoin: '',
		returnVal: {
			coin: '',
		},
	};

	return sammCoin => {
		const tradeCoinSmall = String(sammCoin).toLowerCase();

		if (sammCoin && memoCache.sammCoin === tradeCoinSmall) {
			return memoCache.returnVal;
		}

		const coinParts = tradeCoinSmall.split('-');
		const coin = coinParts[0];
		const basePair = getBaseProps(coinParts[1]);

		memoCache.returnVal = {
			coin,
			basePair,
		};
		memoCache.sammCoin = tradeCoinSmall;

		return memoCache.returnVal;
	};
})();

export const getBasePropsFromCoin = (() => {
	const memoCache = {
		coin: '',
		props: {},
	};

	return (coinId = 0) => {
		if (memoCache.coin === coinId) {
			return memoCache.props;
		}

		const defaultProps = markets.inr;

		marketsList.forEach(mkt => {
			const { coinId: c_id } = markets[mkt];

			if (c_id === coinId) {
				memoCache.coin = coinId;
				memoCache.props = markets[mkt];
			}
		});

		return (memoCache.coin && memoCache.props) || defaultProps;
	};
})();

export const isMarginCoin = coin => marginCoins.includes(coin?.toLowerCase());

export const currencies = {
	inr: {
		id: 0,
		name: 'Indian Rupee',
		short: 'INR ₹',
		curr: 'INR',
		sym: '₹',
		numberFormat: 'en-IN',
		decimals: 2,
	},
	usdt: {
		id: 1,
		name: 'Dollar',
		curr: 'USDT',
		short: 'USDT $',
		sym: '$',
		numberFormat: 'en-US',
		decimals: 2,
	},
	aed: {
		id: 2,
		name: 'Dirham',
		short: 'AED',
		curr: 'AED',
		sym: 'AED ',
		numberFormat: 'en-US',
		decimals: 2,
	},
	thb: {
		id: 24,
		name: 'Baht',
		short: 'THB ฿',
		curr: 'THB',
		sym: '฿',
		numberFormat: 'en-US',
		decimals: 2,
	},
	idr: {
		id: 3,
		name: 'Rupiah',
		short: 'IDR Rp',
		curr: 'IDR',
		sym: 'Rp ',
		numberFormat: 'en-US',
		decimals: 2,
	},
	try: {
		id: 25,
		name: 'Lira',
		short: 'TRY ₺',
		curr: 'TRY',
		sym: '₺',
		numberFormat: 'tr-TR',
		decimals: 2,
	},
};

export const currenciesList = Object.keys(currencies);

export const getCurrencyProperty = (currency = 'inr', prop) => {
	const shortCurrency = currency.toLowerCase();

	if (
		currenciesList.indexOf(shortCurrency) > -1 &&
		hasOwn(currencies[shortCurrency], prop)
	) {
		return currencies[shortCurrency][prop];
	}

	return false;
};

const getCurrenciesListWithCode = () => {
	const obj = {};
	currenciesList.forEach(currency => {
		Object.assign(obj, {
			[getCurrencyProperty(currency, 'id')]: currency,
		});
	});
	return obj;
};

export const currenciesWithIdsList = getCurrenciesListWithCode();

export const getCurrencyFromCode = currencyId => {
	if (
		Number.isNaN(currencyId) ||
		!hasOwn(currenciesWithIdsList, currencyId)
	) {
		return 'inr';
	}
	return currenciesWithIdsList[currencyId];
};

export const getCurrencyProps = (() => {
	const memoCache = {
		currency: '',
		props: {},
	};

	return (currency = 'inr') => {
		const curr = String(currency).toLowerCase();

		if (memoCache.currency === curr) {
			return memoCache.props;
		}

		const defaultProps = currencies.inr;

		if (hasOwn(currencies, curr)) {
			memoCache.currency = curr;
			memoCache.props = currencies[curr];

			return memoCache.props;
		}

		return defaultProps;
	};
})();

export const countries = {
	in: {
		id: 0,
		iso: 356,
		name: 'India',
		short: 'IND',
		curr: 'INR',
		hasP2P: true,
		currCode: 0,
		sym: '₹',
		numberFormat: 'en-IN',
		fiatDeposit: true,
		fiatWithdraw: true,
		kyc: {
			selfieItems: 'Aadhar Card or PAN Card',
			idProof: {
				name: 'PAN Card',
				uploads: {
					must: ['Front'],
				},
			},
			addressProof: {
				name: 'Aadhaar Card',
				uploads: {
					must: ['Front', 'Back'],
				},
			},
		},
		bank: {
			acc: {
				name: 'bankAccount.bankAcc',
				condition: {
					autoComplete: 'off',
				},
			},
			ifsc: {
				name: 'bankAccount.ifsc',
				condition: {
					length: 11,
					autofill: true,
					autoComplete: 'bank ifsc',
				},
			},
			mobile: {
				name: 'bankAccount.mobile',
				type: 'tel',
				label: 'bankAccount.mobileLabel.in',
				condition: {
					autoComplete: 'home tel',
					length: 10,
				},
			},
			branch: {
				name: 'bankAccount.mobileName',
				condition: {
					autoComplete: 'bank branch',
				},
			},
			name: {
				name: 'bankAccount.name',
				condition: {
					autoComplete: 'name',
				},
			},
			type: {
				name: 'bankAccount.accountType',
				type: 'radio',
				fields: [
					'bankAccount.accTypes.savings',
					'bankAccount.accTypes.salary',
					'bankAccount.accTypes.current',
				],
			},
			bank_name: {
				name: 'bankAccount.bankName',
				condition: {
					autoComplete: 'bank name',
				},
			},
		},
	},
	all: {
		id: 1,
		short: 'OTHERS',
		name: 'Others',
		curr: 'USDT',
		hasP2P: false,
		sym: '$',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		kyc: {
			selfieItems: 'Passport, Driving License',
			idProof: {
				name: 'Govt issued ID',
				label: 'You can enter any Government issued ID details containing date of birth',
				uploads: {
					must: ['Front'],
					optional: ['Back'],
				},
			},
			addressProof: {
				name: 'Government Issued ID with Address Proof',
				label: 'Government Issued ID with Address Proof is any Government issued document containing your address. It can be Passport, Voter ID, Driving License, etc.',
				uploads: {
					must: ['Front', 'Back'],
				},
			},
		},
		languageCode: 'en',

		bank: {
			acc: {
				name: 'bankAccount.bankAcc',
				condition: {
					autoComplete: 'off',
				},
			},
			ifsc: {
				name: 'bankAccount.swiftCode',
				condition: {
					autoComplete: 'bank swift',
				},
			},
			mobile: {
				name: 'bankAccount.mobile',
				type: 'tel',
				condition: {
					autoComplete: 'home tel',
				},
			},
			branch: {
				name: 'bankAccount.branchName',
				condition: {
					autoComplete: 'bank branch',
				},
			},
			name: {
				name: 'bankAccount.name',
				condition: {
					autoComplete: 'name',
				},
			},
			type: {
				name: 'bankAccount.accountType',
				type: 'radio',
				fields: [
					'bankAccount.accTypes.savings',
					'bankAccount.accTypes.salary',
					'bankAccount.accTypes.current',
				],
			},
			bank_name: {
				name: 'bankAccount.bankName',
				condition: {
					autoComplete: 'bank name',
				},
			},
		},
	},
	ae: {
		id: 2,
		iso: 784,
		name: 'United Arab Emirates',
		short: 'UAE',
		curr: 'AED',
		sym: 'AED ',
		hasP2P: true,
		currCode: 2,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		kyc: {
			selfieItems: 'Emirates ID, Passport, Driving License',
			idProof: {
				name: 'Emirates ID',
				uploads: {
					must: ['Front', 'Back'],
				},
			},
			addressProof: {
				name: 'Government Issued ID with Address Proof',
				label: 'Government Issued ID with Address Proof is any Government issued document containing your address. It can be Passport, Voter ID, Driving License, etc.',
				uploads: {
					must: ['Front', 'Back'],
				},
			},
		},
		bank: {
			acc: {
				name: 'bankAccount.bankAcc',
				condition: {
					autoComplete: 'off',
				},
			},
			ibank: {
				name: 'bankAccount.ibanNumber',
				condition: {
					autoComplete: 'off',
				},
			},
			ifsc: {
				name: 'bankAccount.swiftCode',
				condition: {
					autoComplete: 'bank swift',
				},
			},
			mobile: {
				name: 'bankAccount.mobile',
				type: 'tel',
				condition: {
					autoComplete: 'home tel',
				},
			},
			branch: {
				name: 'bankAccount.branchName',
				condition: {
					autoComplete: 'bank branch',
				},
			},
			name: {
				name: 'bankAccount.name',
				condition: {
					autoComplete: 'name',
				},
			},
			type: {
				name: 'bankAccount.accountType',
				type: 'radio',
				fields: ['Savings', 'Salary', 'Current'],
			},
			bank_name: {
				name: 'bankAccount.bankName',
				condition: {
					autoComplete: 'bank name',
				},
			},
			bankStatement: {
				name: 'bankAccount.bankStatement.ae.title',
				label: 'bankAccount.bankStatement.ae.label',
				format: '.pdf,.jpg,.jpeg,.png',
			},
		},
	},
	id: {
		id: 3,
		iso: 360,
		name: 'Indonesia',
		short: 'IDN',
		currCode: 3,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		hasP2P: true,
		curr: 'IDR',
		sym: 'Rp ',
	},
	br: {
		id: 4,
		iso: 76,
		name: 'Brazil',
		short: 'BRA',
		hasP2P: false,
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'BRL',
		sym: 'R$',
	},
	ng: {
		id: 5,
		iso: 566,
		name: 'Nigeria',
		short: 'NGA',
		currCode: 1,
		hasP2P: false,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: '₦',
		sym: '$',
	},
	bd: {
		id: 6,
		iso: 50,
		name: 'Bangladesh',
		short: 'BGD',
		currCode: 1,
		hasP2P: false,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'BDT',
		sym: '৳',
	},
	ru: {
		id: 7,
		iso: 643,
		name: 'Russia',
		short: 'RUS',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'RUB',
		sym: '‎₽',
		hasP2P: false,
	},
	mx: {
		id: 8,
		iso: 484,
		name: 'Mexico',
		short: 'MEX',
		currCode: 1,
		hasP2P: false,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'MXN',
		sym: '$',
	},
	ar: {
		id: 9,
		iso: 32,
		name: 'Argentina',
		short: 'ARG',
		currCode: 1,
		hasP2P: false,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'ARS',
		sym: '$',
	},
	ve: {
		id: 10,
		iso: 862,
		name: 'Venezuela',
		short: 'VEN',
		hasP2P: false,
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'VES',
		sym: 'Bs.',
	},
	fr: {
		id: 11,
		iso: 250,
		name: 'France',
		short: 'FRA',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'EUR',
		sym: '€',
		hasP2P: false,
	},
	de: {
		id: 12,
		iso: 276,
		name: 'Germany',
		short: 'DEU',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'EUR',
		sym: '€',
		hasP2P: false,
	},
	es: {
		id: 13,
		iso: 724,
		name: 'Spain',
		short: 'ESP',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'EUR',
		sym: '€',
		hasP2P: false,
	},
	sa: {
		id: 14,
		iso: 682,
		name: 'Saudi Arabia',
		short: 'SAU',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'SAR',
		sym: 'SR',
		hasP2P: false,
	},
	ca: {
		id: 15,
		iso: 124,
		name: 'Canada',
		short: 'CAN',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'CAD',
		sym: '$',
		hasP2P: false,
	},
	nl: {
		id: 16,
		iso: 528,
		name: 'Netherlands',
		short: 'NLD',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'EUR',
		sym: '€',
		hasP2P: false,
	},
	se: {
		id: 17,
		iso: 752,
		name: 'Sweden',
		short: 'SWE',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'SEK',
		sym: 'kr',
	},
	sg: {
		id: 18,
		iso: 702,
		name: 'Singapore',
		short: 'SGP',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'SGD',
		sym: 'S$',
		hasP2P: false,
	},
	au: {
		id: 19,
		iso: 36,
		name: 'Australia',
		short: 'AUS',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'AUD',
		sym: '$',
		hasP2P: false,
	},
	nz: {
		id: 20,
		iso: 554,
		name: 'New Zealand',
		short: 'NZL',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'NZD',
		sym: '$',
		hasP2P: false,
	},
	cn: {
		id: 21,
		iso: 156,
		name: 'China',
		short: 'CHN',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'CNY',
		sym: '¥',
		hasP2P: false,
	},
	ph: {
		id: 22,
		iso: 608,
		name: 'Philippines',
		short: 'PHL',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'PHP',
		sym: '₱',
		hasP2P: false,
	},
	it: {
		id: 23,
		iso: 380,
		name: 'Italy',
		short: 'ITA',
		currCode: 1,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'EUR',
		sym: '€',
		hasP2P: false,
	},
	th: {
		id: 24,
		iso: 764,
		name: 'Thailand',
		short: 'THA',
		currCode: 24,
		numberFormat: 'en-US',
		fiatDeposit: false,
		fiatWithdraw: false,
		curr: 'THB',
		sym: '฿',
		hasP2P: true,
	},
	tr: {
		id: 25,
		iso: 792,
		homeLinks: '/tr',
		name: 'Turkey',
		short: 'TUR',
		currCode: 25,
		numberFormat: 'en-US',
		fiatDeposit: true,
		fiatWithdraw: true,
		curr: 'TRY',
		sym: '₺',
		hasP2P: false,
		noMargin: true,
		noFd: false,
		noFutures: true,
		noQuickSwap: true,
		noSip: true,
		noOptions: true,
		noSprinkVouchers: true,
		noPredictNWin: true,
		noFinanceExtras: true,
		languageCode: 'tr',
		appLink: {
			bns: {
				android:
					'https://play.google.com/store/apps/details?id=com.bitbns.tr',
				ios: 'https://itunes.apple.com/in/app/bitbns-crypto-trading-exchange/id1346160076',
			},
		},
		bank: {
			ibank: {
				name: 'bankAccount.ibanNumber',
				condition: {
					autoComplete: 'off',
					required: true,
				},
			},
			// name: {
			// 	name: 'bankAccount.name',
			// 	condition: {
			// 		autoComplete: 'name',
			// 	},
			// },
			// bank_name: {
			// 	name: 'bankAccount.bankName',
			// 	condition: {
			// 		autoComplete: 'bank name',
			// 	},
			// },
		},
	},
};

export const countriesList = Object.keys(countries).sort((a, b) =>
	countries[a].name > countries[b].name ? 1 : -1
);

export const justCountriesList = countriesList.filter(c => c !== 'all');

export const getCountryProperty = (country = 'all', prop) => {
	const lowerCountry = country.toLowerCase();

	if (
		countriesList.indexOf(lowerCountry) > -1 &&
		hasOwn(countries[lowerCountry], prop)
	) {
		return countries[lowerCountry][prop];
	}
	if (hasOwn(countries.all, prop)) {
		return countries.all[prop];
	}

	return false;
};

const getCountriesListWithCode = () => {
	const obj = {};
	countriesList.forEach(country => {
		Object.assign(obj, {
			[getCountryProperty(country, 'id')]: country,
		});
	});
	return obj;
};

export const countriesWithIdsList = getCountriesListWithCode();

export const getCountryFromCode = countryId => {
	if (Number.isNaN(countryId) || !hasOwn(countriesWithIdsList, countryId)) {
		return 'in';
	}
	return countriesWithIdsList[countryId];
};

export const getCountryProps = (() => {
	const memoCache = {
		country: '',
		props: {},
	};

	return (country = 'all') => {
		const ctry = String(country).toLowerCase();

		if (memoCache.country === ctry) {
			return memoCache.props;
		}

		const defaultProps = countries.inr;

		if (hasOwn(countries, ctry)) {
			memoCache.country = ctry;
			memoCache.props = {
				...countries.all,
				...countries[ctry],
			};

			return memoCache.props;
		}

		return defaultProps;
	};
})();

const defaultAppsLinksSet = {
	bns: {
		android: 'https://play.google.com/store/apps/details?id=com.bitbns',
		ios: 'https://itunes.apple.com/in/app/bitbns-crypto-trading-exchange/id1346160076',
	},
	bnsPay: {
		android: 'https://play.google.com/store/apps/details?id=com.bitbnspay',
		ios: 'https://apps.apple.com/in/app/bnspay/id1572500597',
	},
	arbitrage: {
		android:
			'https://play.google.com/store/apps/details?id=com.bitbns.arbitrage',
	},
};

export const getAppLinkFromCountry = country => {
	const { appLink } = getCountryProps(country) || {};

	if (appLink) {
		return { ...defaultAppsLinksSet, ...appLink };
	}

	return defaultAppsLinksSet;
};

// export const getWalletProps = (() => {
// 	const memoized = {
// 		coin: '',
// 		props: {},
// 	};

// 	return coin => {
// 		const lowerCoin = typeof coin === 'string' && coin.toLowerCase();

// 		if (memoized.coin === lowerCoin) {
// 			return memoized.props;
// 		}

// 		const defaultValue = false;

// 		if (coinsList.indexOf(lowerCoin) > -1) {
// 			memoized.props = coinParams[lowerCoin];
// 			return memoized.props;
// 		}
// 		return defaultValue;
// 	};
// })();

// export const getWalletProperty = (coin, prop) => {
// 	const lowerCoin = typeof coin === 'string' && coin.toLowerCase();
// 	const walletProps = getWalletProps(lowerCoin);

// 	if (hasOwn(walletProps, prop)) {
// 		return walletProps[prop];
// 	}
// 	return false;
// };

export const taggedAddressType = taggedAddress => {
	switch (taggedAddress) {
		case 1:
			return 'Tag';
		case 2:
			return 'Memo';
		case 3:
			return 'Message';
		case 4:
			return 'Payment ID';
		default:
			return null;
	}
};

export const depositNotes = (
	coin,
	coinName,
	hasMultipleNetworks,
	additionalNotes
) => {
	const upperCoin = coin.toUpperCase();

	const notes = [];

	if (Array.isArray(additionalNotes)) {
		notes.push(...additionalNotes);
	}
	if (hasMultipleNetworks) {
		notes.push(
			`${coinName} ${upperCoin} is on multiple networks!  **So please double check while you deposit**`
		);
	}

	return notes;
};
